var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"fixed":_vm.fixed,"app":""}},[_c('span',{staticStyle:{"margin":"10px"}},[_vm._v("©"+_vm._s(new Date().getFullYear())+" GoPear Technologies")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74cbaa4e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/PageFooter.vue
// module id = WXNI
// module chunks = 0